var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:[_vm.baseClass, _vm.variantClass, _vm.$attrs.class],on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[(_vm.$slots.icon)?_c('span',{staticClass:"mr-2 flex items-center"},[_vm._t("icon")],2):_vm._e(),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }